import { protectedComponentHoc } from "../../components/ProtectedComponent";
import ServiceKeysComponent from "./component";

export const ServiceKeys = protectedComponentHoc(ServiceKeysComponent);
